module.exports = __webpack_public_path__ + "static/media/back_icon.8bccb340.svg";